module.exports = __webpack_public_path__ + "static/media/frothluxe-5.9ba8db52.jpg";